import apiFetch from '../apiFetch'
export default function (token, conditionDocumentalId) {
  return apiFetch({ endPoint: `conditionDocumental/details/${conditionDocumentalId}`, method: 'GET', body: null, token: token })
}
